import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Container,
  Form,
  FormFeedback,
  Input,
  InputGroup,
  InputGroupText,
  Label
} from "reactstrap"
import withRouter from "../../components/Common/withRouter"
import { get, handleApiError, patch, post } from "../../helpers/api_helper"
import toastr from "toastr"

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    oldPassword: "",
    plainPassword: "",
  });

  const [user, setUser] = useState(null);
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const isFormValid = formData.oldPassword.trim() !== "" && formData.plainPassword.trim() !== "";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: null });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    setLoading(true);
    try {
      const response = await patch(`/users/${user.id}/change-password`, formData);
      if (204 === response.status) {
        toastr.info('Vos modifications ont été enregistrées avec succès.', '');
      }
    } catch (error) {
      handleApiError(error.response.data);
    } finally {
      setLoading(false);
    }
  };

  const getInfoUser = async () => {
    const response = await get('users/me');
    if (200 === response.status) {
      setUser(response.data);
    }
  }

  useEffect(() => {
    getInfoUser();
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <h4 className="card-title mb-4">Changer votre mot de passe</h4>
          <Card>
            <CardBody>
              <Form className="form-horizontal" onSubmit={handleSubmit}>
                <div className="form-group">
                  <Label className="form-label">Ancien mot de passe</Label>
                  <InputGroup>
                    <Input
                      name="oldPassword"
                      type={showOldPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Entrez l'ancien mot de passe"
                      value={formData.oldPassword}
                      onChange={handleChange}
                      invalid={!!errors.oldPassword}
                    />
                    <InputGroupText onClick={() => setShowOldPassword(!showOldPassword)} style={{ cursor: "pointer" }}>
                      {showOldPassword ? <i className="bx bx-hide font-size-18" /> : <i className="bx bx-show font-size-18" />}
                    </InputGroupText>
                  </InputGroup>
                  {errors.oldPassword && (
                    <FormFeedback type="invalid">{errors.oldPassword}</FormFeedback>
                  )}
                </div>

                <div className="form-group mt-3">
                  <Label className="form-label">Nouveau mot de passe</Label>
                  <InputGroup>
                    <Input
                      name="plainPassword"
                      type={showNewPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Entrez le nouveau mot de passe"
                      value={formData.plainPassword}
                      onChange={handleChange}
                      invalid={!!errors.plainPassword}
                    />
                    <InputGroupText onClick={() => setShowNewPassword(!showNewPassword)} style={{ cursor: "pointer" }}>
                      {showNewPassword ? <i className="bx bx-hide font-size-18" /> : <i className="bx bx-show font-size-18" />}
                    </InputGroupText>
                  </InputGroup>
                  {errors.plainPassword && (
                    <FormFeedback type="invalid">{errors.plainPassword}</FormFeedback>
                  )}
                </div>

                <div className="text-center mt-4">
                  <Button
                    color="primary"
                    className="w-50 d-flex align-items-center justify-content-center rounded-5 mx-auto"
                    disabled={!isFormValid}
                  >
                    <i className="bx bx-check me-2"></i>
                    {loading ? "Enregistrement..." : "Changer le mot de passe"}
                  </Button>
                </div>

                {message && (
                  <div className="alert alert-info text-center mt-3" role="alert">
                    {message}
                  </div>
                )}
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};


export default withRouter(ChangePassword);
